import { connect, useDispatch } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useMutation } from "@apollo/client";
import PropTypes from "prop-types";

import { isAuthenticated } from "../../../pages/auth/redux/authSelector";
import { logout } from "../../../pages/auth/redux/authSlice";
import { LOGOUT } from "../../../graphql/mutations/auth";
import { showErrorToast } from "../../common/CustomErrorMessage";
import { removeTokenFromLocalStorage } from "../../../services/AuthService";

function LogoutPage(props) {
  const dispatch = useDispatch();
  const { history } = props;
  const [logoutMutation] = useMutation(LOGOUT, {
    onCompleted: (data) => {
      if (data.logout) {
        removeTokenFromLocalStorage();
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const onLogout = async () => {
    dispatch(logout());
    history.push("/login");
    await logoutMutation();
  };

  return (
    <Link className="dropdown-item ai-icon" onClick={onLogout}>
      <svg
        id="icon-logout"
        xmlns="http://www.w3.org/2000/svg"
        className="text-danger me-1"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1={21} y1={12} x2={9} y2={12} />
      </svg>
      <span className="ms-2">Logout </span>
    </Link>
  );
}

LogoutPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));
